import React from "react";
import "./Home.css"
import AlbumGrid from "./AlbumGrid";

const Home = () => {
    
    return(
        <AlbumGrid/> 
    );
}

export default Home